/**
 * A video that did not convert. The "Try again with the same file" button shows
 * ONLY when the server says the same file can pass (`retryable`). When it
 * cannot (not a video, too long, wrong shape), the admin is told to choose a
 * different file with the Replace control above; there is no second upload control.
 * Kept apart from VideoUploadPanel because that file reaches the API module,
 * which the render tests cannot load.
 */
import { XCircle } from 'lucide-react';

interface Props {
  fileName: string;
  error: string;
  retryable: boolean;
  disabled: boolean;
  onRetry: () => void;
}

export function UploadFailure({ fileName, error, retryable, disabled, onRetry }: Props) {
  return (
    <div role="alert" className="flex gap-2 rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-800 dark:border-red-800 dark:bg-red-950 dark:text-red-200">
      <XCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div className="space-y-2">
        <p className="font-medium">The video is not ready: {fileName}</p>
        <p>{error}</p>
        {retryable && !disabled && (
          <button type="button" onClick={onRetry} className="rounded-md border border-current px-3 py-1 text-xs font-medium">
            Try again with the same file
          </button>
        )}
        {!retryable && <p>This file cannot work. Choose a different file.</p>}
      </div>
    </div>
  );
}
